import 'leaflet-velocity'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import 'leaflet-timedimension'
import { selectSerie } from '../../uiTools/pronosticoMarinoUtils'
import PronosticoMarinoPunto from '../pronostico/pronosticoMarinoPunto'
import DateUtils from '../../inumet_js_lib/utils/dateUtils'
import SelectorPuerto from './SelectorPuerto'
import { Grid } from '@mui/material'

import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

const MeteogramasMarino = ({
    dataPuertos,
    horasPronostico,
    horasResolTemporal,
}) => {
    let [indexPuntoSel, setIndexPuntoSel] = useState(0)

    const theme = useTheme()
    let mcel = useMediaQuery(theme.breakpoints.down('md'))

    if (dataPuertos && dataPuertos.puertos) {
        let itemsContent = []
        let opcionesSelectorPuerto = []
        dataPuertos.puertos.forEach((itemDataPuerto, index) => {
            opcionesSelectorPuerto.push({
                value: index,
                label: itemDataPuerto.Nombre,
            })

            itemsContent.push(
                <PronosticoMarinoPunto
                    visible={indexPuntoSel === index}
                    key={index}
                    nombrePunto={itemDataPuerto.Nombre}
                    nombreSerie={itemDataPuerto.Nombre}
                    serieDirViento={selectSerie(
                        itemDataPuerto.Variables,
                        'windDirection'
                    )}
                    serieIntViento={selectSerie(
                        itemDataPuerto.Variables,
                        'windSpeed'
                    )}
                    serieIntRafaga={selectSerie(
                        itemDataPuerto.Variables,
                        'windRafagasGFS'
                    )}
                    seriePrecipitacion={selectSerie(
                        itemDataPuerto.Variables,
                        'precipitacionHoraGFS'
                    )}
                    serieAltOla={selectSerie(
                        itemDataPuerto.Variables,
                        'significantHeightCombinedWindWavesSwell'
                    )}
                    seriePeriodoOla={selectSerie(
                        itemDataPuerto.Variables,
                        'primaryWaveMeanPeriod'
                    )}
                    serieDirOla={selectSerie(
                        itemDataPuerto.Variables,
                        'directWaveSwellWind'
                    )}
                    serieTempAire={selectSerie(
                        itemDataPuerto.Variables,
                        'temperaturaSuperficieGFS'
                    )}
                    seriePresion={selectSerie(
                        itemDataPuerto.Variables,
                        'pressioneNivelMarGFS'
                    )}
                    serieTotalCieloCubierto={selectSerie(
                        itemDataPuerto.Variables,
                        'totalCieloCubiertoGFS'
                    )}
                    fechaInicio={DateUtils.parseDate(dataPuertos.corrida)}
                    horasPronostico={horasPronostico}
                    resolucionTemporalHoras={horasResolTemporal}
                />
            )
        })
        return (
            <Grid container>
                <Grid item xs={mcel ? 12 : 6} sx={{ padding: '20px' }}>
                    <SelectorPuerto
                        puntos={opcionesSelectorPuerto}
                        val={indexPuntoSel}
                        onSelect={(val) => {
                            setIndexPuntoSel(val)
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    {itemsContent}
                </Grid>
            </Grid>
        )
    }

    return <></>
}

export default MeteogramasMarino

MeteogramasMarino.propTypes = {
    dataPuertos: PropTypes.object,
    horasPronostico: PropTypes.number,
    horasResolTemporal: PropTypes.number,
}
